import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import BillApprovalDetails from "components/modal/BillApprovalDetails"; // Ensure this is correctly imported
import { notifyError, notifySuccess } from "utils/toast";
import ItineraryModal from "components/form/ItineraryModal";
import BillApprovalServices from "services/BillApprovalServices";
import { FiFile } from "react-icons/fi";
import DriverAproveRejectModel from "components/modal/DriverAproveRejectModel";
import Tooltip from "@mui/material/Tooltip";
const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
const BillApprovalTable = ({
  billapproval,
  perpage,
  currentPage,
  hideEdit,
}) => {
  const { setIsUpdate } = useContext(SidebarContext);
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [billamount, setBillamount] = useState(null);
  const [clientid, setClientid] = useState(null);
  const [currentid, setcurrentid] = useState(null);
  const [, setOpenModal] = useState(false);
  const [itinerary, setItinerary] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
    setSelectedData(null);
    setError("");
  };

  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const handleSubmit = async (
    selectedIds,
    remainingAmount,
    remarks,
    adjusted_amount,
    client_id = null,
    va_current_id = null,
  ) => {
    const payload = {
      va_id_json: JSON.stringify(selectedIds),
      id_client: clientid || client_id,
      va_current_id: currentid || va_current_id,
      approved_amount: remainingAmount,
      rawAdjustAmount: adjusted_amount,
      employee_id: adminInfo?.id,
      bill_adjusted_remark: remarks,
    };

    try {
      const response = await BillApprovalServices.adjustOutstanding(payload);
      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        setError("Failed to update the Bill Approval.");
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("An error occurred while updating Bill Approval.");
    }
  };

  const renderImage = (imgUrl, index, onClickHandler) => (
    <img
      key={index}
      src={process.env.REACT_APP_API_IMAGE_URL + imgUrl}
      alt={`Bill Image ${index + 1}`}
      onClick={onClickHandler}
      className="w-12 h-12 object-cover rounded mr-2 cursor-pointer inline-block border border-gray-300 hover:scale-105 transition-transform"
    />
  );

  const handleStatusChange = (vaId) => {
    setSelectedBill({ id: vaId });
    setIsRemarkModalOpen(true);
  };

  const handleModalAction = async (action, remark) => {
    try {
      var payload = {};

      if (action === "approve") {
        payload.status = 1;
      } else if (action === "reject") {
        payload.status = 2;
        payload.reject_reason = remark;
      }

      const response = await BillApprovalServices.approvebill(
        selectedBill.id,
        payload,
      );

      if (response.status) {
        setIsUpdate(true);
        return notifySuccess(response.message);
      } else {
        return notifyError(response.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      return notifyError("Error updating status.");
    } finally {
      setIsRemarkModalOpen(false);
      setSelectedBill(null);
    }
  };

  return (
    <>
      <BillApprovalDetails
        isOpen={showModal}
        onClose={closeModal}
        handleSubmit={handleSubmit}
        data={selectedData}
        billAmount={billamount}
        error={error}
      />
      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />
      <TableBody>
        {billapproval
          .slice((currentPage - 1) * perpage, currentPage * perpage)
          .map((data, index) => (
            // <TableRow key={data.id} className="text-center">
            <TableRow
              key={index}
              className={`text-center ${
                data.booking_status === 1 ? "bg-red-100 dark:bg-gray-500" : ""
              }`}
            >
              <TableCell className="text-xs text-center">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-xs text-center">
                {data.ref_no}
              </TableCell>

              <TableCell className="text-xs text-center">
                {data.client_name}
              </TableCell>
              <TableCell>
                <div className="flex flex-col items-center">
                  <span className="text-sm">{data.start_date}</span>
                  <span className="text-sm">{data.end_date}</span>
                </div>
              </TableCell>
              {hideEdit && (
                <TableCell>
                  {data.itinerary && (
                    <div className="flex flex-col items-center row-gap-4 justify-center">
                      <span
                        onClick={() => {
                          setShowItineraryModal(true);
                          setItinerary(data.itinerary);
                        }}
                        title="Itinerary"
                        className="cursor-pointer text-xl  text-green-500"
                      >
                        <FiFile />
                      </span>
                    </div>
                  )}
                </TableCell>
              )}
              <TableCell>
                <div className="text-sm flex flex-col items-center space-y-3">
                  <span className="text-sm">{data.vendor_name}</span>
                </div>
              </TableCell>
              <TableCell>
                <div className="text-sm flex flex-col items-center space-y-3">
                  <span className="text-sm">{data.trip_advance_paid}</span>
                </div>
              </TableCell>
              <TableCell>
                <div className="text-sm flex flex-col items-center space-y-3">
                  <span className="text-sm">{data.TDS}</span>
                </div>
              </TableCell>

              <TableCell>
                <div className="text-sm flex flex-col items-center space-y-3">
                  <span className="text-sm">{data.bill_amount}</span>
                </div>
              </TableCell>

              <TableCell>
                <span className="text-sm">{data.days_difference}</span>
              </TableCell>
              <TableCell>
                <span className="text-sm">
                  {data?.bill_adjusted_status === 0
                    ? (data?.remaining_individual_amt ?? 0)
                    : (data?.remaining_individual_amt ?? 0) - (data?.TDS ?? 0)}
                </span>
              </TableCell>

              <TableCell className="text-center">
                {Array.isArray(data?.bill_images)
                  ? data.bill_images.map((image, i) =>
                      renderImage(image, i, () => openZoomModal(image)),
                    )
                  : typeof data?.bill_images === "string"
                    ? data.bill_images
                        .split(",")
                        .map((image, i) =>
                          renderImage(image.trim(), i, () =>
                            openZoomModal(image.trim()),
                          ),
                        )
                    : null}
              </TableCell>

              <TableCell>
                {/* {hideEdit == 1 ? (
                  data.bill_adjusted_status == 0 ? (
                    <span
                      className="text-sm text-center text-green-500 cursor-pointer"
                      onClick={async () => {
                        try {
                          const response =
                            await BillApprovalServices.checkoutstanding(
                              data.vendor_id
                            );

                          let amount =
                            Math.round(
                              ((data?.remaining_individual_amt ?? 0) -
                                (data?.TDS ?? 0)) *
                                100
                            ) / 100;

                          if (response?.status) {
                            setSelectedData([]);
                            setBillamount(amount);
                            setClientid(data.id_client);
                            setcurrentid(data.va_id);

                            if (response.data.length > 0) {
                              setSelectedData(response.data);
                              setShowModal(true);
                            } else {
                              setShowModal(false);
                              setSelectedData([]);
                              handleSubmit(
                                [],
                                amount,
                                "",
                                0,
                                data.id_client,
                                data.va_id
                              );
                            }
                          } else {
                            setError("Failed to fetch Bill Approval details.");
                          }
                        } catch (error) {
                          console.error("API Error:", error);
                          setError(
                            "An error occurred while fetching Bill Approval details."
                          );
                        }
                      }}
                    >
                      Bill Approval
                    </span>
                  ) : (
                    <span className="text-sm text-center text-pink-500">
                      Approved
                    </span>
                  )
                ) : 
                data.bill_adjusted_status == 0 ? (
                  <span className="text-sm text-center text-red-500">
                    Not Approved
                  </span>
                ) : (
                  <span className="text-sm text-center text-pink-500">
                    Approved
                  </span>
                )} */}

                {/* New updation */}
                {Number(data.bill_adjusted_status) === 0 ? (
                  <span
                    className="text-sm text-center text-green-500 cursor-pointer"
                    onClick={() => handleStatusChange(data?.va_id)}
                  >
                    Bill Approval
                  </span>
                ) : (
                  <span className="text-sm text-center text-pink-500">
                    Approved
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
        {isRemarkModalOpen && (
          <DriverAproveRejectModel
            isOpen={isRemarkModalOpen}
            onClose={() => setIsRemarkModalOpen(false)}
            title="Approve or Reject"
            newStatus={selectedBill.newStatus}
            onYesClick={() => handleModalAction("approve", "Approved")}
            onRejectClick={(remark) => {
              handleModalAction("reject", remark);
            }}
          />
        )}

        {isModalOpen && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={() => setIsModalOpen(false)}
          >
            <div
              className="bg-white pb-4 pl-4 pr-4 pt-2 rounded shadow-lg max-w-full max-h-full overflow-auto"
              onClick={(e) => e.stopPropagation()}
              style={{ height: "70vh", overflowY: "scroll" }}
            >
              <p
                className="text-right mb-0 mt-0 cursor-pointer font-bold"
                onClick={() => setIsModalOpen(false)}
              >
                X
              </p>
              <img
                src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                alt="Selected Image"
                className="max-w-full max-h-full"
              />
            </div>
          </div>
        )}
      </TableBody>
    </>
  );
};

export default BillApprovalTable;
